import React, { useContext, useEffect } from 'react'
import { CategoryModalFragment } from '#src/generated/graphql'
import CategoryModalContent from '../CategoryModalContent'
import { AnalyticsContext } from '#src/containers/Analytics'
import styles from './styles.css'

interface V2Props {
  category: CategoryModalFragment
  brandName: string
  pathUrl: string
}

const V2: React.SFC<V2Props> = ({ category, brandName, pathUrl }) => {
  const analytics = useContext(AnalyticsContext)

  useEffect(() => {
    analytics?.events.engagementChannelViewed({
      engagement_channel: 'full-page-takeover',
      variation: 'v2'
    })
  }, [])

  switch (category.slug) {
    case 'golf-clubs':
    case 'golf-bags':
    case 'golf-gloves':
    case 'golf-balls':
    case 'golf-rangefinders':
    case 'golf-tees':
      return (
        <CategoryModalContent
          headline={
            <>
              We have 161 golf experts who specialize in fitting {brandName}{' '}
              <span className={styles.lowercase}>{category.pluralDisplayName}</span>.
            </>
          }
          categorySlug={category.slug}
          variation="v2"
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          pathUrl={pathUrl}
        />
      )

    case 'electric-bikes':
    case 'mountain-bikes':
    case 'bike-helmets':
    case 'bike-locks':
    case 'bike-pumps':
    case 'bike-tire-repair':
    case 'bike-mirrors':
    case 'bike-cleats':
    case 'bike-frames':
    case 'bike-pedals':
      return (
        <CategoryModalContent
          headline={
            <>
              We have 21 bike experts who specialize in fitting {brandName}{' '}
              <span className={styles.lowercase}>{category.pluralDisplayName}</span>.
            </>
          }
          categorySlug={category.slug}
          variation="v2"
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          pathUrl={pathUrl}
        />
      )

    case 'skis':
    case 'ski-boots':
    case 'ski-bindings':
    case 'ski-poles':
      return (
        <CategoryModalContent
          headline={
            <>
              We have 57 ski experts who specialize in fitting {brandName}{' '}
              <span className={styles.lowercase}>{category.pluralDisplayName}</span>
            </>
          }
          categorySlug={category.slug}
          variation="v2"
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          pathUrl={pathUrl}
        />
      )

    case 'snowboards':
    case 'snowboard-boots':
    case 'snowboard-bindings':
      return (
        <CategoryModalContent
          headline={
            <>
              We have 57 snowboard experts who specialize in fitting {brandName}{' '}
              <span className={styles.lowercase}>{category.pluralDisplayName}</span>
            </>
          }
          categorySlug={category.slug}
          variation="v2"
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          pathUrl={pathUrl}
        />
      )

    case 'winter-sports-jackets':
    case 'winter-sports-gloves':
    case 'winter-sports-pants':
      return (
        <CategoryModalContent
          headline={
            <>
              We have 57 winter sports experts who specialize in fitting {brandName}{' '}
              <span className={styles.lowercase}>{category.pluralDisplayName}</span>
            </>
          }
          categorySlug={category.slug}
          variation="v2"
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          pathUrl={pathUrl}
        />
      )

    default:
      return (
        <CategoryModalContent
          headline={<>We have hundreds of experts you can ask about this {brandName} item</>}
          smallHeadline={'Chat with one now'}
          buttonText={'Get free expert advice'}
          categorySlug={category.slug}
          variation="v2"
          pathUrl={pathUrl}
        />
      )
  }
}

export default V2
